import React from "react";

// Libraries
import SVG from "react-inlinesvg";
import { useHistory } from "react-router-dom";

// Components
import { Button, Flex } from "components";

// Resources
import logo from "assets/img/Blockchain/logo.svg";
import styles from "./BlockchainHeader.module.scss";

export const BlockchainHeader: React.FC = () => {
  const history = useHistory();

  const handleOnClick = () => {
    history.push("/system/dashboard");
  };

  return (
    <Flex className={styles.header} container containerAlignItems="flex-end" containerJustifyContent="space-between">
      <Flex item itemGutter>
        <SVG src={logo} />
      </Flex>

      <Flex item itemGutter>
        <Button caption="Visit breedr.co" onClick={handleOnClick} />
      </Flex>
    </Flex>
  );
};
